"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["component", "href", "src"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ShineLogo = function ShineLogo(props) {
  var Component = props.component,
      href = props.href,
      src = props.src,
      rest = _objectWithoutProperties(props, _excluded);

  var logo = /*#__PURE__*/_react["default"].createElement("img", _extends({}, rest, {
    alt: "Shine Wedding Invitations",
    src: src
  }));

  var wrapperProps = {};

  if (Component === 'a') {
    wrapperProps.href = href;
  }

  return /*#__PURE__*/_react["default"].createElement(Component, wrapperProps, logo);
};

ShineLogo.defaultProps = {
  component: 'a',
  href: 'https://www.shineweddinginvitations.com',
  src: 'https://static.shineweddinginvitations.com/catalog/Shine-LogoType.svg'
};
ShineLogo.propTypes = {
  component: _propTypes["default"].oneOf(['a', 'div']),
  href: _propTypes["default"].string,
  src: _propTypes["default"].string
};
var _default = ShineLogo;
exports["default"] = _default;